import { Route, Navigate, useParams } from "react-router-dom";
import { Protected } from "./ui";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PatientForm from "./pages/PatientForm";
import PatientDetail from "./pages/PatientDetail";
import Compare from "./pages/Compare";
import Visor from "./pages/Visor";
import CaseView from "./pages/CaseView";
import PatientConfirm from "./pages/PatientConfirm";

const LegacyFicha = () => {
  const { id } = useParams();
  return <Navigate to={id === "new" ? "/pacientes/nuevo" : `/pacientes/${id}/editar`} replace />;
};
const P = (el) => <Protected>{el}</Protected>;

/** Rutas del panel clínico. Se insertan dentro del <Routes> de cada sitio. */
export const panelRoutes = () => [
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="cita" path="/cita/:token" element={<PatientConfirm />} />,
  <Route key="dash" path="/dashboard" element={P(<Dashboard />)} />,
  <Route key="agenda" path="/agenda" element={<Navigate to="/dashboard?tab=agenda" replace />} />,
  <Route key="pnew" path="/pacientes/nuevo" element={P(<PatientForm />)} />,
  <Route key="pedit" path="/pacientes/:id/editar" element={P(<PatientForm />)} />,
  <Route key="pcmp" path="/pacientes/:id/comparar" element={P(<Compare />)} />,
  <Route key="pdet" path="/pacientes/:id" element={P(<PatientDetail />)} />,
  <Route key="visor" path="/visor/:id" element={P(<Visor />)} />,
  <Route key="caso" path="/caso/:id" element={P(<CaseView />)} />,
  <Route key="ficha" path="/ficha/:id" element={<LegacyFicha />} />,
];
